"use client";

import { usePathname } from "next/navigation";
import Link from "next/link";

export default function NavRail() {
  const pathname = usePathname();

  const isActive = (path: string) => {
    if (path === "/home") return pathname === "/home" || pathname === "/";
    return pathname.startsWith(path);
  };

  return (
    <div className="rail">
      <div className="logo">V</div>
      <nav className="nav">
        <Link href="/home" className={`ni ${isActive("/home") ? "on" : ""}`}>
          <svg viewBox="0 0 24 24">
            <path d="M3 11l9-8 9 8M5 10v10h14V10" />
          </svg>
        </Link>

        <Link href="/chat" className={`ni ${isActive("/chat") ? "on" : ""}`}>
          <svg viewBox="0 0 24 24">
            <path d="M4 5h16v11H9l-4 4V5z" />
          </svg>
        </Link>

        <Link href="/mia" className={`ni ${isActive("/mia") ? "on" : ""}`} title="Mia">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2M12 20v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M2 12h2M20 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
          </svg>
        </Link>

        <div className="sep" />

        <Link href="/tasks" className={`ni ${isActive("/tasks") ? "on" : ""}`}>
          <svg viewBox="0 0 24 24">
            <path d="M9 6h11M9 12h11M9 18h11M4 6l1 1 2-2M4 12l1 1 2-2" />
          </svg>
        </Link>

        <Link href="/projects" className={`ni ${isActive("/projects") ? "on" : ""}`}>
          <svg viewBox="0 0 24 24">
            <path d="M3 7h6l2 2h10v9H3z" />
          </svg>
        </Link>

        <Link href="/team" className={`ni ${isActive("/team") ? "on" : ""}`}>
          <svg viewBox="0 0 24 24">
            <circle cx="9" cy="8" r="3" />
            <path d="M3 20c0-3 3-5 6-5s6 2 6 5M17 7a3 3 0 010 6" />
          </svg>
        </Link>

        <div className="sep" />

        <Link href="/kpis" className={`ni ${isActive("/kpis") ? "on" : ""}`}>
          <svg viewBox="0 0 24 24">
            <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
          </svg>
        </Link>

        <Link href="/finanzas" className={`ni ${isActive("/finanzas") ? "on" : ""}`}>
          <svg viewBox="0 0 24 24">
            <path d="M12 2v20M7 6h7a3 3 0 010 6H7h8a3 3 0 010 6H6" />
          </svg>
        </Link>

        <Link href="/reputacion" className={`ni ${isActive("/reputacion") ? "on" : ""}`}>
          <svg viewBox="0 0 24 24">
            <path d="M12 3l2.5 5 5.5.8-4 3.9.9 5.5L12 17l-4.9 1.1.9-5.5-4-3.9 5.5-.8z" />
          </svg>
        </Link>

        <Link href="/system" className={`ni ${isActive("/system") ? "on" : ""}`}>
          <svg viewBox="0 0 24 24">
            <path d="M4 5h16v11H4zM9 20h6M12 16v4" />
          </svg>
        </Link>
      </nav>
      <div className="me">D</div>
    </div>
  );
}
